import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';




const baseURLS = window.location.origin === 'https://admin.astrocall.live'
  ? 'https://api.astrocall.live/api/'
  : 'https://liveapi.astrocall.live/api/';


const CUSTOM_API_URL = `${baseURLS}Authorize/GetToken`;


const dynamicCustomApiUrl = baseURLS.replace(
  /^https:\/\/[^/]+\/api\//,
  baseURLS
);








export const login = (username, password) => {
    const postData = { "username": username, 'password': password, grant_type: 'password', }
  
    return axios.post(CUSTOM_API_URL, postData);
}

export function signUp(email, password) {
    
    const postData = { email, password, returnSecureToken: true, };
    return axios.post(`https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`, postData,);
}



export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
          
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
           
            swal("Oops", "Email not found", "error", { button: "Try Again!", });
            break;
        case 'INVALID_PASSWORD':
         
            swal("Oops", "Invalid Password", "error", { button: "Try Again!", });
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    
    sessionStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function saveUserDataInLocalStorage(Data) {
   
    sessionStorage.setItem('UserData', JSON.stringify(Data));
}

export function runLogoutTimer(dispatch, timer, navigate) {
   
}

export function checkAutoLogin(dispatch, navigate) {
   
    const tokenDetailsString = sessionStorage.getItem('UserData');
    let tokenDetails = '';
    tokenDetails = JSON.parse(tokenDetailsString);
   
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
        return;
    }

  

    dispatch(loginConfirmedAction(tokenDetails));

   
}
